import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import Accrued from './Accrued'
import Carryovers, { CarryOver } from './Carryovers'
import Incidence from './Incidence'

interface Props {
  accrued: number
  carryOvers: CarryOver[]
  incidences: AllowanceIncidence[]
  allowance: Allowance
  stat: AllowanceStat
  thisCycle: string
}

const TotalBreakdown = ({ accrued, carryOvers, incidences, allowance, stat, thisCycle }: Props) => {
  const title = allowance.isDays
    ? i18n.t('time_off.new_counter.total_row.days')
    : i18n.t('time_off.new_counter.total_row.hours')

  const totalAdjustment = stat.attributes.incidences
  const totalCarryover = stat.attributes.accumulated_carry_over

  return (
    <Tooltip title={title}>
      <>
        <Accrued amount={accrued} thisCycle={thisCycle} />
        {Number(totalCarryover) !== 0 &&
          carryOvers.map((carry, index) => {
            return (
              carry.accumulated !== 0 && (
                <Carryovers allowance={allowance} carryOver={carry} key={index} />
              )
            )
          })}
        {totalAdjustment > 0 &&
          incidences.map((allowanceIncidence) => {
            return (
              allowanceIncidence.attributes.days_in_cents > 0 && (
                <Incidence
                  key={allowanceIncidence.attributes.id}
                  allowanceIncidence={allowanceIncidence}
                />
              )
            )
          })}
      </>
    </Tooltip>
  )
}

export default observer(TotalBreakdown)
